import React from 'react';
import styled from 'styled-components';

import { InvisibleIcon, VisibleIcon } from './icons';
import TextInput from '../TextInput';
import { TextInputButton } from '../TextInputStyles';
import PlayupThemeProvider from '../../../themes/PlayupThemeProvider';

const TextInputRevealPassword = React.forwardRef<HTMLInputElement, TextInputProps>(
	({ type = 'password', ...props }, ref) => {
		const [isPasswordVisible, setIsPasswordVisible] = React.useState(type !== 'password');
		const buttonWidth = '2.4rem';

		return (
			<PlayupThemeProvider>
				<TextInput
					errorTextAlign={props.errorTextAlign ?? 'center'}
					ref={ref}
					type={isPasswordVisible ? 'text' : 'password'}
					rightButton={
						<VisibilityButton
							width={buttonWidth}
							onClick={() => setIsPasswordVisible(!isPasswordVisible)}
							type="button"
							title={isPasswordVisible ? 'Hide Password' : 'Reveal Password'}
						>
							{isPasswordVisible ? <VisibleIcon height="100%" /> : <InvisibleIcon height="100%" />}
						</VisibilityButton>
					}
					rightButtonWidth={buttonWidth}
					{...props}
				/>
			</PlayupThemeProvider>
		);
	}
);

export default TextInputRevealPassword;

const VisibilityButton = styled(TextInputButton)`
	fill: #808285;
	opacity: 0.5;
`;
